<template>
  <section class="scene-actions">

    <div class="action" @click="playToggle">
      <svg class="icon">
        <transition name="fade">
          <use xlink:href="#play" v-if="isPlaying"></use>
        </transition>
        <transition name="fade">
          <use xlink:href="#pause" v-if="!isPlaying"></use>
        </transition>
      </svg>
    </div>

    <div class="action">

      <div class="volume-slider-container">
        <slider-volume :show="videoValueSliderShow"
                       :initial-value="+videoVolume"
                       :is-vertical="true"
                       @valueChange="videoVolumeValueChange"></slider-volume>
      </div>

      <svg class="icon" @click="videoValueSliderShow = !videoValueSliderShow">
        <transition name="fade">
          <use xlink:href="#volume" v-if="+videoVolume > 0"></use>
        </transition>
        <transition name="fade">
          <use xlink:href="#no-volume" v-if="+videoVolume === 0"></use>
        </transition>
      </svg>
    </div>

  </section>
</template>

<script>
  import Tooltip      from '../common/Tooltip'
  import SliderVolume from '../common/slider/Volume'

  export default {
    name: 'SceneActions',

    components: { Tooltip, SliderVolume },

    props: {
      options: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },

    data() {
      return {
        isPlaying: false,
        videoVolume: 0,
        videoValueSliderShow: false
      }
    },

    mounted() {
      if (this.options.hasOwnProperty('video') && this.options.video.hasOwnProperty('volume')) {
        this.videoVolume = +this.options.video.value
      }
    },

    methods: {
      playToggle() {
        this.isPlaying = !this.isPlaying
        this.parameterChange(this.isPlaying ? 'videoPause' : 'videoPlay')
      },

      parameterChange(action, value) {
        this.$emit('parameterChange', { action: action, value: value })
      },

      videoVolumeValueChange(value) {
        this.videoVolume = value
        this.parameterChange('videoVolume', value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/styles/mixins";

  $actions-color: hsla(0, 0%, 100%, 1);

  .scene-actions {
    display: flex;
    position: absolute;
    bottom: 0;
    left: 50%;
    @include transform-translate(-50%, 0);
    color: $actions-color;
    margin: 20px;

    .action {
      width: 40px;
      height: 40px;
      margin: 10px;
      cursor: pointer;

      .icon {
        width: 100%;
        height: 100%;
      }
    }
  }

  .volume-slider-container {
    position: absolute;
    top: -130px;
    left: -10px;
    right: 0;
    margin: 0;
    width: 200px;
    height: 40px;
    @include transform-rotate(270deg);
  }
</style>
